// deps
import dayjs from "dayjs";

/**
 * @typedef {Object} Props
 * @property {import("@internationalized/date").DateValue} date
 * @property {string} [startDate]
 * @property {Object} [availabilities]
 */
/**
 * @param {Props} props
 */
export default function isDateUnavailable({ date, startDate, availabilities }) {
  const currentDate = dayjs(date.toDate("UTC")).format("YYYY-MM-DD");

  // Ferme les jours si pas d'horaires disponibles
  if (!availabilities) {
    return true;
  }

  // Ferme les jours non disponibles
  if (!availabilities[currentDate]) {
    return true;
  }

  // Si startDate est sélectionné, vérifier que currentDate est un jour disponible après startDate
  if (startDate && startDate !== "") {
    // Récupérer toutes les dates disponibles après startDate
    const availableEndDates = Object.keys(
      availabilities[startDate] ?? {},
    ).flatMap((hour) => Object.keys(availabilities[startDate][hour] ?? {}));

    // Si currentDate n'est pas dans les jours disponibles, on le bloque
    if (!availableEndDates.includes(currentDate)) {
      return true;
    }
  }

  // Ouverture des horaires
  return false;
}
